<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-row>
          <b-col cols="6">
            <h4 v-if="empresa.cadastroFederal !== '' && empresa.razaoSocial !== ''">
              {{ empresa.cadastroFederal + " - " + empresa.razaoSocial }}
            </h4>
          </b-col>
          <b-col cols="6">
            <div
              style="display: flex;justify-content: flex-end;align-items: end; flex-direction: column;"
            >
              <div style="display: flex;justify-content: flex-end;align-items: baseline;">
                <b-form-checkbox
                  v-model="ativo"
                  checked="true"
                  name="check-button"
                  switch
                  @change="inativaEmpresa"
                >
                  <label style="font-size: 1rem">Empresa ativa</label>
                </b-form-checkbox>
                <div
                  v-b-tooltip.hover.lefttop
                  style="margin-left: 10px;"
                  title="Histórico de inativação"
                  @click="abrirModalHistorico"
                >
                  <font-awesome-icon
                    :icon="faHistory"
                    style="color:#c1af1d"
                  />
                </div>
              </div>
              <div
                style="display:flex; word-wrap: break-word;margin-right: 0.5rem;"
              >
                <div
                  v-if="!ativo && empresa.historico && empresa.historico.usuario != null"
                  style="font-size:12px; display: flex; flex-direction: column;"
                  class="form-text text-muted textbox"
                >
                  <span><strong style="font-weight:bold;">Inativada em: </strong>{{ empresa.historico.dataCadastro }}</span>
                  <span><strong style="font-weight:bold;">Usuário:</strong> {{ empresa.historico.usuario }}</span>
                  <span><strong style="font-weight:bold;">Motivo:</strong> {{ empresa.historico.motivo }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col
            v-if="empresa.empresaContrato"
            cols="auto"
          >
            <span class="badge badge-warning">
              Cadastro em modo parcial! Motivo: aguardando assinatura do contrato da proposta N°
              <a
                v-if="empresa.numeroProposta && empresa.proposta && empresa.proposta.id"
                :href="urlProposta"
                target="_blank"
                style="color: #1D80F9; text-decoration: underline;"
              >
                {{ empresa.numeroProposta }}
              </a>
              <span v-else>(proposta não disponível)</span>
            </span>
          </b-col>
        </b-row>
        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            no-body
            title="Geral"
          >
            <aba-geral
              v-if="abaAcessada == 0"
              ref="geral"
              :msg-erro="showMsgError"
            />
            <template
              v-if="empresa.emailsBoletosNFs && empresa.emailsBoletosNFs.length == 0 && empresa.id > 0 "
              #title
            >
              Geral
              <feather-icon
                icon="AlertCircleIcon"
                style="margin-left: 5px; color: red;"
              />
            </template>
          </b-tab>

          <b-tab
            no-body
            title="Endereço"
          >
            <aba-endereco
              v-if="abaAcessada == 1"
              ref="endereco"
            />
          </b-tab>

          <b-tab
            no-body
            title="Modelos e documentos"
          >
            <aba-modelo
              v-if="abaAcessada == 2"
              ref="modelo"
            />
            <template
              v-if="empresa.modelo && !empresa.modelo.ativo && empresa.modelo.id > 0"
              #title
            >
              Modelos e documentos
              <feather-icon
                icon="AlertCircleIcon"
                style="margin-left: 5px; color: red;"
              />
            </template>
          </b-tab>

          <b-tab
            v-if="$route.path.indexOf('editar') > 0"
            no-body
            title="Contatos"
          >
            <aba-contato
              v-if="mostrarContatos"
              ref="contato"
            />
            <template
              v-if="atencaoContato"
              #title
            >
              Contatos
              <feather-icon
                icon="AlertCircleIcon"
                style="margin-left: 5px; color: red;"
              />
            </template>
          </b-tab>

          <b-tab
            no-body
            title="Responsáveis"
          >
            <aba-responsavel
              v-if="($route.path.indexOf('editar') > 0) && abaAcessada === 4 || ($route.path.indexOf('novo') > 0 && abaAcessada === 3)"
              ref="responsavel"
              no-body
              title="Contatos da empresa"
            />
            <template
              v-if="atencaoResponsavel"
              #title
            >
              Responsáveis
              <feather-icon
                icon="AlertCircleIcon"
                style="margin-left: 5px; color: red;"
              />
            </template>
          </b-tab>

          <b-tab
            no-body
            title="Societário"
          >
            <aba-societario
              v-if="($route.path.indexOf('editar') > 0) && abaAcessada === 5 || ($route.path.indexOf('novo') > 0 && abaAcessada === 4)"
              ref="abaSocietario"
              :disabled="$route.path.indexOf('novo') > 0 && abaAcessada === 4"
            />
          </b-tab>
          <b-tab
            no-body
            title="Certificados"
          >
            <aba-certificados
              v-if="($route.path.indexOf('editar') > 0) && abaAcessada === 6 || ($route.path.indexOf('novo') > 0 && abaAcessada === 5)"
              ref="abaCertificados"
              :disabled="$route.path.indexOf('novo') > 0 && abaAcessada === 5"
            />
          </b-tab>

          <b-tab
            no-body
            title="Integrações"
          >
            <aba-integracao
              v-if="($route.path.indexOf('editar') > 0) && abaAcessada === 7 || ($route.path.indexOf('novo') > 0 && abaAcessada === 6)"
              ref="abaIntegracoes"
            />
            <template
              v-if="!empresa.idOMIE && (empresa.statusOmie == 1 || empresa.statusOmie == 3)"
              #title
            >
              Integrações
              <feather-icon
                icon="AlertCircleIcon"
                style="margin-left: 5px; color: red;"
              />
            </template>
          </b-tab>
        </b-tabs>
      </template>
    </cadastro-base>
    <b-modal
      id="modal-inativar-empresa"
      ref="modalinativarempresa"
      no-close-on-backdrop
      @close="fecharModal"
    >
      <template #modal-title>
        <h3 class="m-0">
          Confirme os dados para inativar
        </h3>
        <span style="font-size: 10px;">Para que a inativação seja concluída, é necessário salvar o cadastro da empresa.</span>
      </template>
      <validation-observer ref="validacaoInativar">
        <validation-provider
          #default="{ errors }"
          rules="required"
          name="Motivo"
        >
          <span>Informa o motivo:</span>
          <b-select
            v-model="opcaoSelecionada"
            :style="errors[0] ? 'border-color:#ea5455' : ''"
          >
            <option
              v-for="opcao in opcoesDeIntativar"
              :key="opcao"
              :value="opcao"
            >
              {{ opcao }}
            </option>
          </b-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :rules="opcaoSelecionada == 'Outros' ? 'required' : ''"
          name="Observação"
        >
          <b-form-textarea
            id="textarea"
            v-model="descricao"
            :style="opcaoSelecionada == 'Outros' && errors[0] ? 'border-color:#ea5455' : ''"
            class="mt-1"
            placeholder="Observação"
            rows="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </validation-observer>
      <p class="pl-1 pr-1 mt-1 text-center">
        Atenção: caso a empresa tenha cobrança de documentos com os status "Aguardando homologação", "Pendente" e "Recusado", estes serão cancelados pela inativação da empresa.
      </p>
      <template #modal-footer>
        <b-button
          block
          variant="none"
          size="sm"
          class="btn-primary"
          style="margin-left: 0;"
          @click="confirmarInativacaoEmpresa"
        >Inativar</b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-historicos-empresa"
      ref="modalhistoricosempresa"
      no-close-on-backdrop
      size="lg"
    >
      <template #modal-title>
        <h3 class="m-0 font-modal-title-inativacao">
          Histórico de inativação dessa empresa
        </h3>
      </template>
      <div>
        <tabela-historico-inativacao :historicos="historicos" />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="none"
          size="sm"
          class="btn-primary"
          style="margin-left: 0;"
          @click="cancel()"
        >Ok</b-button>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">
.font-modal-title-inativacao {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.45;
}
</style>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '../../services/api'

export default {
  name: 'Funcao',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    ValidationObserver,
    CadastroBase: () => import('@/shared/components/cadastro-base/CadastroBase.vue'),
    AbaGeral: () => import('../aba-geral/AbaGeral.vue'),
    AbaModelo: () => import('../aba-modelo/AbaModelo.vue'),
    AbaEndereco: () => import('../aba-endereco/AbaEndereco.vue'),
    AbaResponsavel: () => import('../responsavel-departamento/ResponsavelDepartamento.vue'),
    AbaContato: () => import('../aba-contato/AbaContato.vue'),
    AbaSocietario: () => import('../aba-societario/AbaSocietario.vue'),
    AbaCertificados: () => import('../aba-certificados/AbaCertificados.vue'),
    AbaIntegracao: () => import('../aba-integracoes/AbaIntegracao.vue'),
    TabelaHistoricoInativacao: () => import('../tabela-historico-inativacao/TabelaHistoricoInativacao.vue'),
  },
  data() {
    return {
      faHistory,
      required,
      acessouModelos: false,
      mostrarContatos: false,
      abaAcessada: 0,
      ativo: true,
      atencaoContato: false,
      atencaoResponsavel: false,
      showMsgError: false,
      opcoesDeIntativar: ['Baixa', 'Transferência de saída', 'Inadimplência', 'Outros'],
      opcaoSelecionada: null,
      descricao: null,
      historicosColunas: [
        { field: 'dataCadastro', label: 'Data' },
        { field: 'tipoHistorico', label: 'Ação' },
        { field: 'motivo', label: 'motivo' },
        { field: 'dataBaixa', label: 'Usuário' },
      ],
      historicos: [],
      urlProposta: null,
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa', 'empresaToSave']),
  },
  created() {
    this.inicializaEmpresa()
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions('empresa', ['setEmpresa', 'inicializaEmpresa', 'setDadosInativacao']),
    carregar(id) {
      api.getEmpresa(id)
        .then(payload => {
          this.ativo = payload.data.ativo
          this.atencaoContato = payload.data.hasUsuarioExternoInativo
          this.atencaoResponsavel = payload.data.hasResponsavelInativo
          this.setEmpresa(payload.data)
          this.urlProposta = `${window.location.origin}/painel-proposta/proposta/${payload.data.proposta?.id}`
        })
    },
    validarCamposObrigatoriosAbaGeral() {
      return ((this.empresaToSave.emailsBoletosNFs && this.empresaToSave.emailsBoletosNFs.length > 0)
           && (this.empresaToSave.razaoSocial || this.empresaToSave.razaoSocial !== '')
           && (this.empresaToSave.cadastroFederal || this.empresaToSave.cadastroFederal !== ''))
    },
    salvar() {
      if (!this.empresa.incricaoExist && this.validarCamposObrigatoriosAbaGeral()) {
        return new Promise((resolve, reject) => {
          const toSave = this.empresaToSave
          toSave.ativo = this.ativo
          if (toSave.clienteFixo === null || toSave.clienteFixo === undefined) {
            toSave.clienteFixo = false
          }
          if (this.state === 'novo') {
            api.createEmpresa(toSave)
              .then(() => {
                this.fechar()
                resolve('Empresa cadastrada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          } else {
            const formData = this.getFormDataBody(toSave)
            api.updateEmpresa(toSave.id, formData)
              .then(() => {
                this.fechar()
                resolve('Empresa alterada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          }
        })
      }
      if (!this.validarCamposObrigatoriosAbaGeral()) {
        this.showMsgError = true
        this.$erro('Preencha os campos corretamente')
        return null
      }
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Já existe outra empresa cadastrada com o mesmo número de inscrição',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
      return null
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'empresas' })
      } else {
        this.$router.go(-1)
      }
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
      if (newIndex === 3) {
        this.mostrarContatos = true
      } else {
        this.mostrarContatos = false
      }
    },
    inativaEmpresa() {
      if (!this.ativo && this.empresa.id != null && this.empresa.id > 0) {
        this.abrirModal()
      } else if (this.ativo && this.empresa.id != null && this.empresa.id > 0) {
        this.$swal({
          title: 'Deseja realmente ativar o cadastro dessa empresa?',
          confirmButtonText: 'Confirma',
          cancelButtonText: 'Cancela',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'warning',
          type: 'question',
          customClass: {
            title: 'modal-title',
            confirmButton: 'mr-1 w-25 btn-primary',
            cancelButton: 'w-25 btn-danger',
          },
        })
          .then(result => {
            if (result.value) {
              this.ativo = true
            } else {
              this.ativo = false
            }
          })
      }
    },
    format(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    getFormDataBody(body) {
      const newBory = body
      const formData = new window.FormData()
      if (this.$refs.abaSocietario) {
        const arquivo = this.$refs.abaSocietario.getArquivosAnexados()
        if (arquivo.contratual) {
          const nomeArquivoContratual = arquivo.contratual.filename || arquivo.contratual.name
          formData.append('files', arquivo.contratual.file, `contratual;${nomeArquivoContratual}`)
        }
        if (arquivo.outros) {
          const nomeArquivoOutros = arquivo.outros.filename || arquivo.outros.name
          formData.append('files', arquivo.outros.file, `outros;${nomeArquivoOutros}`)
        }
      }
      if (newBory.cnaeSecundarios.length === 1 && newBory.cnaeSecundarios[0].code == null) {
        newBory.cnaeSecundarios = []
      }

      formData.append('body', JSON.stringify(newBory))

      return formData
    },
    abrirModal() {
      this.$refs.modalinativarempresa.show()
    },
    fecharModal() {
      this.ativo = true
      this.$refs.modalinativarempresa.hide()
    },
    abrirModalHistorico() {
      api.getHistoricosEmpresa(this.empresa.id).then(payload => {
        this.historicos = payload.data
        this.$refs.modalhistoricosempresa.show()
      })
        .catch(err => {
          this.$erro(err)
        })
    },
    fecharModalHistorico() {
      this.$refs.modalhistoricosempresa.hide()
    },
    confirmarInativacaoEmpresa() {
      this.$refs.validacaoInativar.validate()
        .then(success => {
          if (success) {
            this.ativo = false
            this.setDadosInativacao({ motivo: this.opcaoSelecionada, observacao: this.descricao })
            this.$refs.modalinativarempresa.hide()
          }
        })
        .catch(() => {
          this.$erro('Preencha os campos corretamente')
        })
    },
  },
}
</script>
